import { Modal, Button, Text } from "@eventsquare/uikit";
import { Product } from "@type/products";
import { useAppContext } from "@context/appContext";
import { useState } from "react";
import styles from "./AmountModal.module.scss";

interface AmountModalProps {
  showModal: boolean;
  setShowModal: (show: boolean) => void;
  product: Product | null;
  onConfirm: (product: Product, amount: number) => void;
}

const AmountModal = ({
  showModal,
  setShowModal,
  product,
  onConfirm,
}: AmountModalProps) => {
  const { cart = [] } = useAppContext();
  const initialAmount =
    cart.find((item) => item.uid === product?.uid)?.quantity || 0;
  const [amount, setAmount] = useState(initialAmount);

  const closeModal = () => {
    setShowModal(false);
    setAmount(initialAmount);
  };

  const handleConfirm = () => {
    if (product) {
      onConfirm(product, amount);
    }
  };

  const handleIncrement = () => {
    setAmount((prev) => prev + 1);
  };

  const handleDecrement = () => {
    setAmount((prev) => (prev > 0 ? prev - 1 : 0));
  };

  if (!product) return null;

  return (
    <Modal isVisible={showModal} closeModal={closeModal}>
      <div className={styles.modalContent}>
        <Text variant="h2" noMargin>
          Hold {product.name}
        </Text>
        <div className={styles.amountControls}>
          <Button onClick={handleDecrement}>−</Button>
          <Text variant="h3" noMargin>
            {amount}
          </Text>
          <Button onClick={handleIncrement}>+</Button>
        </div>
        <div className={styles.modalActions}>
          <Button onClick={handleConfirm}>Confirm</Button>
          <Button onClick={closeModal}>Cancel</Button>
        </div>
      </div>
    </Modal>
  );
};

export default AmountModal;
